export default __webpack_public_path__ + "static/media/logo.7f4154cd.png";